import { InfoCircleOutlined } from "@ant-design/icons"

const InfoLabel = ({ children }) => {
    return <div className="text-gray-500 text-xs flex items-center gap-1"><InfoCircleOutlined /> {children}</div>
}

export default InfoLabel